<template>
  <v-app style="background-color: white">
    <div class="bckdiv">
      <v-container>
          <v-layout align-center justify-center style="margin-top:140px">
              <v-flex xs12 md8>
                <h1 class="white--text p-5" style="text-align:center">Rules & Regulation</h1>

              </v-flex>

             
                         </v-layout>
                         
              </v-container>
    </div>
    
    <v-container max>
      <h2 class="txt_my" style="text-decoration: underline;padding-top: 50px;font-weight: bold;">RULES & REGULATIONS</h2>
      <p class="txt_my" style="text-align: justify;font-size: 16px;padding-top: 25px;">
        • Particulars in the tour every tourist has to finish his/her name, age, sex,(male/female).Enrolment can be done by depositing 4000/-. For travelling in non AC II tyre/III tyre, AIR/Ssip Rs.7000 has to be deposited per tourist. The balance amount has to be cleared before 20 days of journey date the booking cancelled the advanced amount Cash/Cheque/Draft, would be refused as per terms & conditions mentioned in the advance receipt.<br/><br/>
• Booking can be made by cash payment/ Cheque /draft. In case of cheque or draft it should be any bank situated in Kolkata clearing zone. Cheque or draft to be issued in favour of Majumder Special A/c.Pay.<br/><br/>
• If the journey is cancelled after full payment, the refund will be made as per terms & conditions printed in the advanced receipt.<br/><br/>
• Under no circumstances any compensation will be paid Berth- Reservation is made in the sleeper class of railway coach & seats is reserved in bus during the tour.<br/><br/>
• Tour manager is provided in every tour to assist the tourist both vegetarian & non vegetarian are served .Breakfast with tea, lunch is served with rice dalfry, dalna ,fish/egg & chatni. In afternoon tea with snacks, at dinner Roti/Rice,Fry, Dalna, Meat & salad.<br/><br/>
• Vegeterian dish is reserved where non-veg item is restricted menu is alternate as per situation.<br/><br/>
• The cost of guide if taken and the entry fee to any temple/religious places to be borne by the tourist. Under situation beyond control, the tour programme can be altered/ shortened.<br/><br/>
• The organization will not be liable for falling to reach the place/places in due date & time, for reason beyond control or the place of visit remains closed.<br/><br/>
• Under the circumstances the company will not make any refund/ compensation. Kanha forest M.P.& Dwarka & Gir forest in Gujrat remain closed from July to October.<br/><br/>
• Allocation of berth in train is governed by the Railway authority & allotment of seat in Bus is controlled by travel agency itself.<br/><br/>
• Accomodation can be provided by AIR/Upper class in Railway coaches on payment of excess amount if informed in advance.
      </p>

      <h2 class="txt_my" style="text-decoration: underline;padding-top: 50px;font-weight: bold;">If necessary L.T.C/ L.F.C/L,F.C certificate / money receipt can be issued.</h2>
      <p class="txt_my" style="text-align: justify;font-size: 16px;padding-top: 25px;">
        • The exact date and time of journey is mentioned in the final receipt.<br/><br/>
• Besides, Xerox copies of tour programme are served to every tourist. The total days of journey are counted from the date of departure to the day of return.<br/><br/>

• If a tourist cancels the journey & applied to us for refund of money along with advance/final receipt. The date of his/her cancellation will be reckoned from the date, the company receives such application. No cancellation request is allowed over phone.<br/><br/>

• Tourists are requested to please go through the rules & regulations printed in the final receipt before making any booking. After making the final payment it will be assumed that the tourist has accepted the rules & regulations of the company.<br/><br/>

• The tour cost may be enhanced due to rise of Bus/Rail/Air/Ship fare, the company will not be liable for any loss of tourist due to any accident or otherwise.<br/><br/>

• No compensation will be paid under such circumstances. Please do not carry the luggage not more than 20 to 22 . Please try to keep light luggage with you and keep watch on your luggage while entraining and detraining. Company will not be liable for any damage of luggage. Group tour can be conducted to religious institutions/School /Collage / office/ Club etc.<br/><br/>

• Tour price is determined as per tour schedule. Majumder Special is well renowned to the middle class people for safe & comfortable journey.<br/><br/>

• All inclusive Viz food. Sight seeing & Up-Dn sleeper class train fare (Except train food, Entry Pass & guide change)<br/><br/>

• Room will be allotted family wise (Minimum 3 heads) in a double bed room. In case of four passengers , one extra matters/cot will be provided in the same double bedroom.<br/><br/>

• Accomodation of kedarnath, Badrinath, Bandhabgarh will be dormitory system.<br/><br/>

• If anybody cancel the tour after reservation of seats the amount shall be refunded to the passengers after deducting the cancellation charge as per the following chart.<br/><br/>

• 50% of the tour cost in reduced for children 3 to 5 years age group & 15% of the tour cost reduced for 5 to 11 years age group of tour mention on the brochure . Below 3 years age group pay only service charge 1200/-.<br/><br/>
      </p>

      <h2 class="txt_my" style="text-decoration: underline;padding-top: 50px;font-weight: bold;">CANCELLATION RULE</h2>
      <h5 class="txt_my">Cancellation charge will be on Full Package cost</h5>
      <p class="txt_my">E mail – salesinfoms@gmail.com</p>

      <p class="txt_my" style="text-align: justify;font-size: 16px;padding-top: 25px;">
        • 120 days before 1st & 2nd class passengers Rs. 500-300+ 5 % per head<br/>
• 100 days before 1st & 2nd class passengers Rs. 500-300+ 10 % per head<br/>
• 80 days before 1st & 2nd class passengers Rs. 500 – 300 + 15 % per head<br/>
• 60 days before 1st & 2nd class passengers Rs. 500 – 300 + 20 % per head<br/>
• 40 days before 1st & 2nd class passengers Rs. 500 – 300 + 40 % per head<br/>
• 25 days before 1st & 2nd class passengers Rs. 500 – 300 + 50 % per head<br/>
• 15 days before 1st & 2nd class passengers Rs. 500 – 300 + 60 % per head<br/>
• 10 days before 1st & 2nd class passengers Rs. 500 – 300 + 80 % per head<br/>
• Refund is allowed if cancellations made within seventy two hours
      </p>

      <h2 style="padding-top: 25px;font-weight: bold;">
        5 % GST tour price extra.<br/>
Train food will not be given in Running train
      </h2>
      <p class="txt_my" style="text-align: justify;">
        <span style="font-weight: bold;">N.B.</span> If the journey is extended due to natural calamity or circumstances beyond control the tourist will be charged extra amount be charged extra amount benefitting with the circumstances.
      </p>
      <p class="txt_my" style="font-weight: bold;">Statutory Warning:</p>
      <p class="txt_my">We have no relation with any other organization in the same name with us.</p>
    </v-container>



    </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
    };
  },
  
};
</script>

<style scoped>
@import '../../HomeCss/home.css';

@import url("https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap");
@import url("https://fonts.googleapis.com/css?family=Anton&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Alice&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Josefin+Slab:ital,wght@0,100..700;1,100..700&display=swap");
</style>

<style scoped>
  v-app {
    font-family: 'Jost', sans-serif!important;

  }
  .txt_my {
  font-family: "Alice", serif !important;
}
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 50px;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.why-us-img img{
 max-width: 100%;
 max-height: 100%;
 margin-bottom: 25px;
}
.about-us-img {
  max-width: 100%;
  border-radius: 5px;
}
.about-us {
  padding: 15px;
}
.about-us .heading-2 {
 
  color: #697488;

}
.why-us-box {
  padding:20px 50px;
}
.why-us p,.why-us-box p {
  color: #697488;
}
.box {
text-align: center;
}
.box h1 {
  color: #051036;
  font-weight: bold;
}
.box p {
  color: #697488;
}
.team-card {
  color:#051036;
}
.team-card img {
  height: 200px;
  width: 200px;
  border-radius: 5px;
  margin-bottom: 15px;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.enquiry {
    font-family: 'Bree Serif', serif;
}
.contact_tag {
    font-family: 'Space Mono', monospace;
}
.bckdiv {
    background-image: url("../../assets/aboutus.jpg");
    height: 400px;
    background-size: cover;
}
@media screen and (max-width: 763px) {
  .rspnsv {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    background-position: center;
    background-size: cover;
  }
  .team-card {
    text-align: center;
  }
  .help {
    padding-right: 0px !important;
  }
  .aboutTop {
      margin-top: 180px;
      margin-bottom: 100px;
  }
}
@media screen and (min-width: 768px){
  .xyz {
      height: 625px;
  }
}
</style>
